import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamation,
  faQuestion, faSync, faThumbsDown, faThumbsUp,
} from '@fortawesome/free-solid-svg-icons';
import Button from '../../components/@base/Button';
import { TestCaseStatus } from '../../dto/TestCaseDTO';
import styles from './ChatbotTesting.module.css';
import ChatbotTestingDetail from './ChatbotTestingDetail';

export default function ChatbotTestingStatus(props) {
  const [showDetail, setShowDetail] = useState(false);

  let icon = <FontAwesomeIcon icon={faQuestion} />;
  let classe = 'ResultNotExecuted';

  switch (props.testCase.status) {
    case TestCaseStatus.FAIL: {
      icon = <FontAwesomeIcon icon={faThumbsDown} />;
      classe = 'ResultFail';
      break;
    }
    case TestCaseStatus.SUCCESS: {
      icon = <FontAwesomeIcon icon={faThumbsUp} />;
      classe = 'ResultSuccess';
      break;
    }
    case TestCaseStatus.IN_PROGRESS: {
      icon = <FontAwesomeIcon icon={faSync} className="spinner" />;
      classe = 'ResultInProgress';
      break;
    }
    case TestCaseStatus.ERROR: {
      icon = <FontAwesomeIcon icon={faExclamation} />;
      classe = 'ResultFail';
      break;
    }
    default: {
      icon = <FontAwesomeIcon icon={faQuestion} />;
      classe = 'ResultNotExecuted';
    }
  }

  const handleShowDetail = () => {
    setShowDetail(true);
  };

  return (
    <>
      {showDetail ? (
        <ChatbotTestingDetail
          testCase={props.testCase}
          setShowDetail={setShowDetail}
        />
      ) : null}

      <Button
        circle
        primary
        small
        title={props.testCase.status}
        classes={styles[classe]}
        onClick={handleShowDetail}
      >
        {icon}
      </Button>
    </>
  );
}
